export default "__VITE_ASSET__zlvoW85a__"